import { render, staticRenderFns } from "./UnityServiceDashboard.vue?vue&type=template&id=0b6ea3b8&scoped=true&"
import script from "./UnityServiceDashboard.vue?vue&type=script&lang=js&"
export * from "./UnityServiceDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6ea3b8",
  null
  
)

export default component.exports